import { render, staticRenderFns } from "./PolicyManagement.vue?vue&type=template&id=6a12b848&"
import script from "./PolicyManagement.vue?vue&type=script&lang=js&"
export * from "./PolicyManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a12b848')) {
      api.createRecord('6a12b848', component.options)
    } else {
      api.reload('6a12b848', component.options)
    }
    module.hot.accept("./PolicyManagement.vue?vue&type=template&id=6a12b848&", function () {
      api.rerender('6a12b848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/PolicyManagement.vue"
export default component.exports